import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@material-ui/core';

const SignupButton = () => {
	const { loginWithRedirect } = useAuth0();
	return (
		<div className='my-4'>
			<Button
				color='secondary'
				fullWidth
				variant='contained'
				onClick={() =>
					loginWithRedirect({
						screen_hint: 'signup',
					})
				}
			>
				Sign Up
			</Button>
		</div>
	);
};

export default SignupButton;
